import { ResourceProps } from '@pankod/refine-core';

export const warehouseResources: ResourceProps[] = [
  {
    name: 'warehouses',
  },
];
